// extracted by mini-css-extract-plugin
module.exports = {"root":"DecisionItem_root__8Hx1B","title":"DecisionItem_title__3rM4W","details":"DecisionItem_details__Z9ItT","type":"DecisionItem_type__ptsjB","time":"DecisionItem_time__QER23"};